module.exports = __webpack_public_path__ + "media/images/wedding/top/reason4-ef95db45d69bc02b6d7b19e32edb2ebc.jpg";